import React, { useCallback, useContext, useState } from 'react';
import { TopBarSelectStateOf, UseTopBarSelectReturn } from './model';

const createContext = () =>
  React.createContext<TopBarSelectStateOf>([{}, () => {}]);

export const context = createContext();

export const TopBarSelectProvider = ({ children }) => {
  const [value, setValue] = useState<TopBarSelectStateOf[0]>({});

  return (
    <context.Provider value={[value, setValue]}>{children}</context.Provider>
  );
};

const useTopBarSelectWithoutProduct = (): UseTopBarSelectReturn<undefined> => {
  const [state, setState] = useContext(context);

  const setProductState = useCallback(
    (newValue: TopBarSelectStateOf[0]): void => {
      setState((prevState) => ({ ...prevState, ...newValue }));
    },
    []
  );

  return [state, setProductState];
};

const useTopBarSelectWithProduct = (
  product: string
): UseTopBarSelectReturn<string> => {
  const [state, setState] = useContext(context);

  const productValue = state[product] || '';

  const setProductState = useCallback(
    (newValue: string | number): void => {
      setState((prevState) => ({ ...prevState, [product]: newValue }));
    },
    [product]
  );

  return [productValue, setProductState];
};

export const useTopBarSelect = <T extends string | undefined>(
  product?: T
): UseTopBarSelectReturn<T> => {
  if (product) {
    return useTopBarSelectWithProduct(product) as UseTopBarSelectReturn<T>;
  }

  return useTopBarSelectWithoutProduct() as UseTopBarSelectReturn<T>;
};
